import { Switch } from "@mui/material";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";
import { SalaryEmployeeListRow } from "src/types/salary";
import { useToggleSalaryEmployeeActive } from "src/api/salary/employees";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { notificationsState } from "src/store/notifications";
import { APIErrorResponse } from "src/types/generic";

const EmployeeActiveToggle = ({
  row,
  refetch,
}: {
  row: SalaryEmployeeListRow;
  refetch: () => void;
}) => {
  const { t } = useTranslation("salary");
  const { t: generalT } = useTranslation("general");
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { mutate, isPending } = useToggleSalaryEmployeeActive();

  const onConfirm = () => {
    mutate(row.id, {
      onSuccess: () => {
        setConfirmOpen(false);
        refetch();
        setNotifications([
          ...notifications,
          { type: "success", message: generalT("updatedSuccessfully") },
        ]);
      },
      onError: (err: APIErrorResponse) => {
        setNotifications([
          ...notifications,
          {
            type: "error",
            message: err?.data?.errors?.[0]?.value ?? generalT("somethingWrong"),
          },
        ]);
      },
    });
  };

  return (
    <>
      <Switch
        size="small"
        checked={row.status}
        onChange={() => setConfirmOpen(true)}
        disabled={isPending}
        inputProps={{ "aria-label": t("toggleActive") }}
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: "#fff",
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "primary.main",
            opacity: 1,
          },
        }}
      />
      <ConfirmPopup
        open={confirmOpen}
        handleClose={() => setConfirmOpen(false)}
        handleConfirm={onConfirm}
        isPending={isPending}
        title={t("toggleActive")}
        subtitle={t("toggleActiveConfirm")}
        confirmBtnText={generalT("confirm")}
        confirmBtnColor="primary"
        noIcon
      />
    </>
  );
};

export default EmployeeActiveToggle;
